<!--
 * @Author: 范向玲
 * @Date: 2023-05-30 10:17:15
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2026-01-15 15:31:50
 * @Description: 消费量---数据管理
 * @FilePath: \web\src\components\DataManagement\consumption\manage\index.vue
-->
<template>
  <div class="consumption-wrap">
    <ItemHead text="矿业消费量数据管理" />
    <section class="search-container">
      <SearchModule @submit="searchHandle" searchType="left" type="xfl" />
      <div class="crud-wrapper">
        <div class="crud-item" @click="sort()">排序</div>
        <!-- <div class="crud-item" @click="add()">新增</div> -->
        <div class="crud-item" @click="importData()">导入</div>
        <div class="crud-item" @click="selectDel()"
          :class="selectedKeys.length > 0 ? 'crud-item-abled' : 'crud-item-disabled'">
          删除
        </div>

        <div class="crud-item" @click="selectDownload()"
          :class="selectedKeys.length > 0 ? 'crud-item-abled' : 'crud-item-disabled'">
          导出
        </div>
      </div>
    </section>
    <!-- <ItemHead text="信息列表" /> -->
    <a-table rowKey="id" class="management-table" :dataSource="tableData" :loading="tableDataLoading" :columns="columns"
      @change="changePage" :row-selection="rowSelection" :scroll="{ y: '90%' }" :pagination="paginationOption">
      <template #serial="{ index }">{{ index + 1 }}</template>
      <template #intervalGrade="{ record }">{{
        record.unitSavour ? record.intervalGrade + ' ' + record.unitSavour : record.intervalGrade
      }}</template>
      <template #action="{ record }">
        <section class="action-icons">
          <i v-for="(item, index) in tableOperationList" :key="index" v-bind="item.option" @click="item.click(record)"
            :class="record.propFlag == '0' ? (item.num == '3' ? 'hide' : '') : ''"
            :style="record.propFlag == '0' ? (item.num == '3' ? 'cursor: not-allowed' : '') : ''">
          </i>
        </section>
      </template>
    </a-table>

    <Modal :option="confirmModalConf" @confirm="confirm" @close="close">
      <template v-slot:main>
        <a-textarea v-model:value="confirmModalConf.remark" placeholder="请填写备注" :rows="8"
          v-if="confirmModalConf.showRemark" />

        <FileUpload v-else-if="confirmModalConf.showUpload" @fileList="importFileList" uploadType="xfl" />
        <section class="detail-modal-container" v-if="confirmModalConf.type === 'sort'">
          <Sort :headerInfo="detailHeaderConf" :code="recordCode" @setSort="setSort" />
        </section>
        <section class="detail-modal-container" v-if="confirmModalConf.type === 'detail'">
          <RecordDetail :headerInfo="detailHeaderConf" :code="recordCode" />
        </section>

        <section class="detail-modal-container" v-if="confirmModalConf.type === 'edit'">
          <RecordEdit :headerInfo="detailHeaderConf" :code="recordCode" :formState="formState" ref="formRef" />
        </section>
      </template>
    </Modal>
  </div>
</template>

<script setup>
import { ref, reactive, computed, toRefs, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Modal from '@/components/lib/Modal/modal1.vue';
import ItemHead from './../component/titleMsg.vue';
import { updateMineralListApi, deleteMineralsReservesApi, reverseDataDownApi, industryReverseApi } from '@/api/dataManagement/ccxm';
import { setSortNewListApi } from '@/api/projectPerformance/reserves';
import AxiosCancelToken from '@/utils/axiosCancelToken';
import { downLoadUtil } from '@/components/utils/utils';
import { GET_RESERVERS_LIBRARY_MANAGE_PAGE } from '@/store/modules/actions/tradeQuantity';
import config from '@/config/config';
import SearchModule from '@/components/DataManagement/tradeQuantity/component/searchLibrary.vue';
import FileUpload from '@/components/lib/Upload/fileUpload1.vue';
import { tableConfig } from './tableConfig.js';
import Sort from './../../reservesLibrary/component/sort.vue';
import RecordDetail from './../../reservesLibrary/component/detail.vue';
import RecordEdit from '../component/edit.vue';

const {
  serveIp: { mine_ip },
} = config;
const axiosCancelToken = new AxiosCancelToken();
const columns = tableConfig;

const router = useRouter();

const { state, dispatch: storeDispatch, commit: storeCommit } = useStore();
// state
const reservesLibraryState = computed(() => state.reservesLibrary);
const { requestParams, tableData, totalCount, tableDataLoading, orenodeResultVisible, activeKey, } = toRefs(
  reservesLibraryState.value,
);
const sortPages = ref([]);
let dataSource = reactive([]);
// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || 'reservesLibrary'}/${methods}`, params);
// 重写dispatch
const dispatch = (space, methods, params) => storeDispatch(`${space || 'reservesLibrary'}/${methods}`, params);

const selectedKeys = ref([]); // 表格选中id
const selectedRowsInfo = ref({});
const formState = ref({});
const selectAll = ref('n  ');
const paginationOption = computed(() => ({
  total: totalCount.value,
  pageSize: requestParams.value.size,
  current: requestParams.value.page,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['6', '10', '20', '30', '40', '50'],
}));
const recordCode = ref('XFL');

// 详情页矿种信息
const detailHeaderConf = reactive([
  {
    label: '矿种',
    value: '',
  },
  {
    label: '单位',
    value: '',
  },
]);

// 确认弹窗 公用
const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  remark: '',
  callback: null,
  showRemark: true,
  showUpload: false,
  showDown: false,
  selectValue: [],
  fileList: [],
});

// 新增编辑弹窗 公用
const modalOption = reactive({
  visible: false,
  loading: false,
  datalist: {},
  modalType: 'default',
});

const modalOption1 = reactive({
  visible: false,
  loading: false,
  datalist: {},
  modalType: 'default',
});

/**
 * @description 表格选中事件
 */
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows, 'onChange');
    selectedKeys.value = selectedRowKeys;
    selectedRowsInfo.value = selectedRows;
  },
  onSelect: (record, selected, selectedRows) => {
    selectAll.value = 'n';
    console.log(record, selected, selectedRows, 'onSelect');
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    selectAll.value = 'y';
    console.log(selected, selectedRows, changeRows, 'onSelectAll');
  },
};

/**
 * @description 单行数据详情跳转
 */
const detailRecord = (record) => {
  detailHeaderConf[0].value = record.commodity;
  detailHeaderConf[1].value = record.unit;
  commit(null, 'setDetailRequestParams', { commodity: record.commodity });
  confirmModalConf.title = '消费量数据';
  confirmModalConf.type = 'detail';
  confirmModalConf.notFooter = true;
  confirmModalConf.width = '10rem';
  confirmModalConf.visible = true;
  confirmModalConf.showRemark = false;
};

/**
 * @description 查询
 */
const searchHandle = (param) => {

  param.code = recordCode.value;
  commit(null, 'setRequestParams', param);
  dispatch(null, GET_RESERVERS_LIBRARY_MANAGE_PAGE, param);
};

/**
 * @description 页码change事件
 */
const changePage = (page) => {
  commit(null, 'setRequestParams', { page: page.current, size: page.pageSize });
  searchHandle(requestParams.value);
};

/**
 * @description 关闭通用弹窗
 */
const close = () => {
  confirmModalConf.remark = '';
  confirmModalConf.visible = false;
  confirmModalConf.showRemark = false;
  confirmModalConf.showUpload = false;
  confirmModalConf.showDown = false;
  confirmModalConf.type = '';
};

/**
 * @description 确认通用弹窗
 */
const confirm = () => {
  confirmModalConf.callback();
};
// -------------------- 删除
/**
 * @description 删除项目
 */
const delProject = (ids) => {
  deleteMineralsReservesApi(ids).then((res) => {
    confirmModalConf.visible = false;
    searchHandle({});
  });
};

/**
 * @description 删除项目之前
 */
const beforeDel = (ids) => {
  confirmModalConf.showRemark = true;
  confirmModalConf.title = '确认删除所选数据？';
  confirmModalConf.callback = () => delProject(ids);
  confirmModalConf.visible = true;
};

/**
 * @description 单行数据删除
 */
const delRecord = (record) => {
  const { id } = record;

  beforeDel([id]);
};

/**
 * @description 勾选删除
 */
const selectDel = () => {
  const ids = selectedKeys.value;

  beforeDel(ids);
};

// -------------------- 导出
// 开始导出
const downloadInfo = (params) => {
  params.check = true;
  reverseDataDownApi(params).then((res) => {
    downLoadUtil(res).then(() => { });
    confirmModalConf.visible = false;
  });
};

// 单行数据下载
const downloadRecord = (record, index) => {
  const { id, code } = record;

  // beforeDownload(record);
  downloadInfo({ code: 'XFL', commodity: record.commodity, exportFlag: 1 });
};
/**
 * @description 勾选导出
 */
const selectDownload = () => {
  const ids = selectedKeys.value;

  let codes = [];

  selectedRowsInfo.value.forEach((i) => {
    codes.push(i.commodity);
  });
  downloadInfo({ code: 'XFL', commodity: codes.join(','), exportFlag: 1 });
};
/* 勾选编辑 */
const selectEdit = () => {
  formState.value = selectedRowsInfo.value;
  confirmModalConf.title = '编辑';
  confirmModalConf.callback = () => submitEdit();
  confirmModalConf.visible = true;
  confirmModalConf.type = 'edit';
  confirmModalConf.width = '8rem';
  confirmModalConf.showRemark = false;
};

const upRecord = (record, index) => {
  if (index <= 0) {
    console.log('已经是第一条了');
  } else {
    let updata = tableData.value[index - 1];

    tableData.value.splice(index - 1, 1);
    tableData.value.splice(index, 0, updata);
  }
};
// 数据下移
const downRecord = (record, index) => {
  if (index === tableData.value.length - 1) {
    console.log('已经是最后一条了');
  } else {
    let downdata = tableData.value[index + 1];

    tableData.value.splice(index + 1, 1);
    tableData.value.splice(index, 0, downdata);
  }
};
/**
 * @description 导入
 */
const importFileList = (data) => {
  confirmModalConf.fileList = data;
};
const xlsxUpload = () => {
  if (confirmModalConf.fileList && confirmModalConf.fileList.length > 0) {
    let formData = new FormData();

    let list = confirmModalConf.fileList;

    list.forEach((file) => {
      formData.append('file', file.originFileObj);
    });
    industryReverseApi(formData).then((res) => {
      if (res.code === 200 && res.data.code === 200) {
        confirmModalConf.visible = false;
        confirmModalConf.showUpload = false;
        confirmModalConf.fileList = [];
        searchHandle(requestParams.value);
      }
    });
  }
};
/**
 * @description 导入按钮点击
 */
const importData = () => {
  confirmModalConf.showRemark = false;
  confirmModalConf.showUpload = true;
  confirmModalConf.title = '导入';
  confirmModalConf.callback = () => xlsxUpload();
  confirmModalConf.visible = true;
  confirmModalConf.width = '5.4rem';
  confirmModalConf.type = '';
  confirmModalConf.showRemark = false;
};
/**
 * @description 新增
 */
const add = () => {
  modalOption.modalType = 'add';
  modalOption.visible = true;
};

/**
 * @description 新增 或者编辑之后的回调事件
 */
const modalRequest = () => {
  searchHandle();
  dispatch('dataAudit', 'GET_MANAGEMENT_INDUSTRY_PAGE');
};
/**
 * @description 排序
 */
const setSort = (ele) => {
  sortPages.value = ele.arr;
};
const submitSort = () => {
  sortPages.value.forEach((item, index) => {
    item.orderNum = index + 1;
  });
  setSortNewListApi(sortPages.value).then((res) => {
    if (res.code === 200 && res.data.code === 200) {
      confirmModalConf.visible = false;
      confirmModalConf.type = '';
      searchHandle({});
    }
  });
};
const sort = () => {
  confirmModalConf.title = '矿种排序';
  confirmModalConf.callback = () => submitSort();
  confirmModalConf.visible = true;
  confirmModalConf.type = 'sort';
  confirmModalConf.width = '10rem';
  confirmModalConf.showRemark = false;
};

/**
 *
 * @param {*} record 预编辑数据信息
 */
// 编辑确认
/**
 *
 * @param {*} record 预编辑数据信息
 */
// 编辑
const formRef = ref();
const submitEdit = () => {
  formRef.value.formRef
    .validate()
    .then(() => {
      updateMineralListApi(formState.value).then((res) => {
        if (res.code === 200 && res.data.code === 200) {
          confirmModalConf.visible = false;
          confirmModalConf.type = '';
          searchHandle({});
        }
      });
    })
    .catch((error) => {
      console.log('error', error);
    });
};


const editRecord = (record) => {
  formState.value = JSON.parse(JSON.stringify(record));
  confirmModalConf.title = '编辑';
  confirmModalConf.callback = () => submitEdit();
  confirmModalConf.visible = true;
  confirmModalConf.type = 'edit';
  confirmModalConf.width = '10rem';
  confirmModalConf.showRemark = false;
  confirmModalConf.notFooter = false
};

const tableOperationList = ref([]);
// 新增 删除的权限控制
const operationConf = [1, 2];

// 操作的权限
const tableOperationListConf = [
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-gengduo',
      title: '详情',
    },
    click: detailRecord,
    operation: [1, 2, 3],
  },
  // {
  //   option: {
  //     style: 'color: rgb(255, 200, 120)',
  //     class: 'iconfont icon-jiantou_xiangshang',
  //     title: '上移',
  //   },
  //   click: upRecord,
  //   operation: [1, 2,],
  // },
  // {
  //   option: {
  //     style: 'color: rgb(255, 200, 120)',
  //     class: 'iconfont icon-jiantou_xiangxia',
  //     title: '下移',
  //   },
  //   click: downRecord,
  //   operation: [1, 2,],
  // },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-bianjishuru',
      title: '编辑',
    },
    click: editRecord,
    operation: [1, 2, 3],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-shanchu',
      title: '删除',
    },
    click: delRecord,
    operation: [1, 2],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-xiazaidaoru',
      title: '下载',
    },
    click: downloadRecord,
    operation: [1, 2],
  },
];

onBeforeMount(() => {
  // window.open('/pdf/024434.pdf');
  commit(null, 'setRequestParams', { startYear: null, endYear: null, source: null, page: 1, size: 10 });
  tableOperationList.value = tableOperationListConf;
  searchHandle({});


});



</script>

<style lang="scss">
.consumption-wrap {
  color: #fff;
  height: 100%;
  background: rgba(179, 150, 92, 0.05);
  left: 0;
  z-index: 100;
  height: 100%;
  padding-right: 0.2rem;

  /* 检索条件 */
  .search-container {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    position: relative;
    padding-left: 0.1rem;
    height: 0.55rem;
    margin-bottom: 0.1rem;
    background: rgba(179, 150, 92, 0.05);

    .crud-wrapper {
      display: flex;
      height: 0.51rem;
      padding: 0.13rem 0;
      position: absolute;
      right: 0;
      top: 0.05rem;

      .crud-item {
        margin-right: 0.04rem;
        width: 0.5rem;
        color: #fff;
        line-height: 0.25rem;
        // background-color: #efb227;
        background-image: url(~@/static/images/dataManagement/curd_btn.png);
        background-size: 100% 100%;
        text-align: center;
      }

      .crud-item-jump {
        width: 0.7rem;
      }

      .crud-item:hover {
        cursor: pointer;
      }

      .crud-item-disabled {
        pointer-events: none;
        color: rgba(255, 255, 255, 0.6);
        // background-color: rgba(239, 178, 39, 0.6);
        opacity: 0.8;
      }

      .crud-item-disabled:hover {
        cursor: no-drop;
      }
    }
  }

  /* 矿种图标 */
  .minerals-img {
    width: 0.6rem;
    height: 0.3rem;
  }

  /* 表格样式 */
  .management-table {
    height: calc(100% - 1.18rem);

    .ant-spin-container {
      display: flex;
      flex-direction: column;
      align-items: end;
    }

    .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table-content {
      height: 100%;
    }

    .ant-table {
      height: calc(100% - .50rem);
      background: none;
      padding-left: 0.1rem;

      .ant-table-scroll {
        height: 100%;
        overflow: visible;
        overflow-x: visible;

        .ant-table-header {
          overflow: visible !important;
          margin-bottom: 0 !important;
        }
      }

      .ant-table-header {
        background: none;
      }

      .ant-table-body {
        overflow-x: hidden !important;
        overflow-y: auto !important;
        background: none;
      }

      /* 矿种 */
      .primary-commodity-img {
        width: 0.8rem;
        height: 0.6rem;
      }

      /* 图标 */
      .action-icons {
        display: flex;
        justify-content: center;

        i {
          font-size: 0.22rem;
          margin-right: 0.04rem;
          cursor: pointer;
        }

        .hide {
          opacity: 0.5;
          color: #666;
        }

        .crud-wrapper {
          display: flex;
          height: 0.25rem;
          padding: 0 0.1rem;
          margin-top: 0.05rem;

          .crud-item {
            margin-right: 0.04rem;
            width: 0.55rem;
            line-height: 0.25rem;
            font-size: 0.1rem;
            color: #fff;
            // background-color: #efb227;
            background-image: url(~@/static/images/dataManagement/curd_btn.png);
            background-size: 100% 100%;
            text-align: center;
          }

          .crud-item:hover {
            cursor: pointer;
          }

          .crud-item-disabled {
            pointer-events: none;
            color: rgba(255, 255, 255, 0.6);
            // background-color: rgba(239, 178, 39, 0.6);
            opacity: 0.8;
          }

          .crud-item-disabled:hover {
            cursor: no-drop;
          }
        }
      }

      .ant-table-thead {
        border: .01rem solid #4d3f1c;
        border-radius: .10rem .10rem 0rem 0rem;
        background: none;
      }

      .ant-table-thead>tr>th {
        color: #dccdab;
        background: rgba(179, 150, 92, 0.2);
        border: none;
      }

      .ant-table-tbody>tr>td {
        background-color: transparent;
        color: #fff;
        border-bottom: .01rem solid rgba(179, 150, 92, 1);
        vertical-align: middle;
      }

      .ant-table-placeholder {
        height: 100%;
        background-color: rgba(77, 63, 28, 1);
        border-top: rgba(179, 150, 92, 1);
        border-bottom: rgba(179, 150, 92, 1);
      }

      .ant-empty-normal {
        color: rgba(179, 150, 92, 1);
      }

      // 暂无数据填充样式
      // .ant-empty-img-simple-path {
      //   fill: rgba(77, 63, 28, 1);
      // }
      // .ant-empty-img-simple-ellipse {
      //   fill: rgba(77, 63, 28, 1);
      // }
      .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-thead>tr:hover.ant-table-row-selected>td,
      .ant-table-tbody>tr:hover.ant-table-row-selected>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-tbody>tr.ant-table-row-selected td {
        background-color: rgba(77, 63, 28, 1);
        color: #fff;
      }
    }
  }
}

.drill-library {
  .search-container {
    .crud-wrapper {
      top: 1.1rem;
    }
  }
}
</style>
